import { render } from "./LabsAdvantage.vue?vue&type=template&id=23605652&scoped=true"
import script from "./LabsAdvantage.vue?vue&type=script&lang=js"
export * from "./LabsAdvantage.vue?vue&type=script&lang=js"

import "./LabsAdvantage.vue?vue&type=style&index=0&id=23605652&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23605652"

export default script